<template>
  <div>
    <div class="table-content row-data" style="margin-bottom: 20px; width: 1000px">
      <el-table
          style="width: 1000px"
          :empty-text="textTable"
          v-loading="loadingData"
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255, 0)"
          :data="listIcon"
          highlight-current-row
          :header-cell-style="tableHeaderColor"
          @selection-change="handleSelectionChange"
          :max-height="$tableMaxHeight"
          border
      >

        <el-table-column
            fixed
            type="index"
            label="STT"
            width="50"
            align="center"
        ></el-table-column>
        <el-table-column fixed prop="idIcon"
                         min-width="150"
                         label="Mã định danh"
                         align="center">
        </el-table-column>
        <el-table-column fixed prop="name"
                         min-width="150"
                         label="Tên"
                         align="center">
        </el-table-column>
        <el-table-column fixed prop="key"
                         min-width="150"
                         label="Key"
                         align="center">
        </el-table-column>
        <el-table-column align="center" width="100" label="Hiển thị">
          <template v-slot:default="scope">
            <el-checkbox
                v-model="scope.row.active"
                @change="handelShowOrHidden(scope.row)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
            label="Tác vụ"
            align="center"
            fixed="right"
            width="200px"
        >
          <template v-slot:default="scope">
            <el-button
                style="margin-left: 20px"
                size="medium"
                type="success"
                @click="handleUpdate(scope.row)"
            >Sửa
            </el-button>
          </template>

        </el-table-column>
      </el-table>
    </div>
    <div style="width: 1000px">
      <el-dropdown @command="handleCommand" style="float: right; margin-top: 10px">
        <el-button class="button-over" type="success">
          Tác vụ
          <i class="el-icon-caret-bottom"/>
        </el-button>
        <el-dropdown-menu class="el-dropdown-menu-container">
          <el-dropdown-item command="createIcon">Thêm Icon</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <CreateIconSystemDialog
        :isCreate="isCreate"
        :listIcon="listIcon"
        @close="handleCloseCreateIconSystemDialog"
    />
    <UpdateIconSystemDialog
        :icon="icon"
        :isUpdate="isUpdate"
        :listIcon="listIcon"
        @close="handleCloseUpdateIconSystemDialog"
    />
  </div>
</template>

<script>
import manageDataService from "@/services/AdminService/ManageDataService";
import CreateIconSystemDialog from "@/views/master/data/CreateIconSystemDialog.vue";
import UpdateIconSystemDialog from "@/views/master/data/UpdateIconSystemDialog.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "ReceiveMessagesSystem",
  components: {UpdateIconSystemDialog, CreateIconSystemDialog},
  data() {
    return {
      textTable: this.$tableEmpty,
      loadingData: true,
      listIcon: [],
      id: 0,
      isCreate: false,
      isUpdate: false,
      icon: {}
    }
  },
  created() {
    this.findAllData()
  },
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold";
    },

    async findAllData() {
      await manageDataService.findAllIconSystem().then((response) => {
        this.listIcon = response.data.data;
      }).catch((error) => {
        console.log(error);
      }).finally(
          this.loadingData = false
      )
    },
    async handelShowOrHidden(row){
       await manageDataService.showIconSystem(row.idIcon,row.active).then(() => {
        if (!row.active) {
          NotifyMessage.leftCornerNotificationSuccess("Ẩn thành công")
        } else {
          NotifyMessage.leftCornerNotificationSuccess("Hiển thị thành công")
        }
      })
       await this.findAllData()
    },
    handleUpdate(row){
      this.icon = row
      this.isUpdate = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCommand(command) {
      if (command === "createIcon") {
        this.showCreateIconSystemDialog()
      }
    },
    showCreateIconSystemDialog() {
      this.isCreate = true;
    },
    handleCloseCreateIconSystemDialog() {
      this.isCreate = false;
      this.findAllData();
    },
    handleCloseUpdateIconSystemDialog() {
      this.isUpdate = false;
      this.findAllData();
    },

  }
}
</script>

<style lang="scss" scoped>
.right-align {
  text-align: right;
}

.container_nav_page {
  display: flex;
  justify-content: center;
}
</style>

